import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/publicaccountnews/list',
    method: 'get',
    params: query
  })
}

export function fetchPublicAccountNews(id) {
  return request({
    url: '/publicaccountnews/detail',
    method: 'get',
    params: { id }
  })
}

export function createPublicAccountNews(data) {
  return request({
    url: '/publicaccountnews/create',
    method: 'post',
    data
  })
}

export function updatePublicAccountNews(data) {
  return request({
    url: '/publicaccountnews/update',
    method: 'post',
    data
  })
}

export function delPublicAccountNews(data) {
  return request({
    url: '/publicaccountnews/del',
    method: 'post',
    data
  })
}

export function editStatus(data) {
  return request({
    url: '/publicaccountnews/status',
    method: 'post',
    data
  })
}

export function editSort(data) {
  return request({
    url: '/publicaccountnews/sort',
    method: 'post',
    data
  })
}
